export default "__VITE_ASSET__54a9a307__$_?component__"